<template>
	<div v-resize="onResize">
		<banner
		:window-size="windowSize"
		:links="links"
		/>
		<component-our-products
		:window-size="windowSize"
		:logos-company="logosCompany"
		/>
		<component-our-team
		:collaborators="collaborators"
		:window-size="windowSize"
		/>
	</div>
</template>

<script>
import banner from '@/components/home/banner';
import componentOurProducts from '@/components/home/component-our-products';
import componentOurTeam from '@/components/home/component-our-team';

function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function data() {
	return {
		links: [
			{
				id: 1,
				name: 'facebook',
				link: 'https://es-la.facebook.com/apprunn/',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/facebook+(1).svg',
				width: 15,
			},
			{
				id: 2,
				name: 'instagram',
				link: 'https://www.instagram.com/apprunn/?igshid=1qlz6flo9sst4',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/instagram-sketched.svg',
				width: 19,
			},
			{
				id: 3,
				name: 'linkedin',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/linkedin+(1).svg',
				link: 'https://www.linkedin.com/company/apprunn',
				width: 19,
			},
			{
				id: 4,
				name: 'youtube',
				link: 'https://www.youtube.com/channel/UCXfyVSRRJbBL1bUGbRqJCSA?disable_polymer=true&nv=1',
				width: 14,
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/play+(2).svg',
			},
		],
		logosCompany: [
			{
				id: 1,
				name: 'gittrack',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/gittrack.svg',
				widthDesktop: '170px',
				widthMobile: '125px',
			},
			{
				id: 2,
				name: 'japisale',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/japisale.svg',
				widthDesktop: '170px',
				widthMobile: '94px',
			},
			{
				id: 3,
				name: 'quipu',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/quipu.svg',
				widthDesktop: '170px',
				widthMobile: '92px',
			},
			{
				id: 4,
				name: 'controlinn',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/controlinn.svg',
				widthMobile: '133px',
			},
			{
				id: 5,
				name: 'smart360',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/smart.svg',
				widthDesktop: '170px',
				widthMobile: '123px',
			},
			{
				id: 6,
				name: 'perudatos',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/perudatos.svg',
				widthDesktop: '170px',
				widthMobile: '149px',
			},
			{
				id: 7,
				name: 'feedBackinn',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/feedbackinn.svg',
				widthDesktop: '170px',
				widthMobile: '142px',
			},
		],
		collaborators: [
			{
				id: 1,
				name: 'Marcelo Carranza',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/marcelo-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/marcelo-min-color.png',
			},
			{
				id: 2,
				name: 'Jorge',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jorge-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jorge-min-color.png',
				carge: '',
			},
			{
				id: 3,
				name: 'ERIC SILVA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/eric-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/eric-min-color.png',
			},
			{
				id: 3,
				name: 'WENDY APAZA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/wendy-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/wendy-min-color.png',
			},
			{
				id: 4,
				name: 'ARELIS CHICCHON',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/arelis-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/arelis-min-color.png',
			},
			{
				id: 5,
				name: 'JOSÉ JUAN DOMINGUEZ',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jose-juan-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jose-juan-min-color.png',
			},
			{
				id: 6,
				name: 'LUIS BOLIVAR',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/luis-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/luis-min-color.png',
			},
			{
				id: 7,
				name: 'JHONN AYALA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jhonn-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jhonn-min-color.png',
			},
			{
				id: 8,
				name: 'CELSO ESPINOZA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/celso-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/celso-min-color.png',
			},
			{
				id: 9,
				name: 'XAVIER DÁVILA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/xavier-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/xavier-min-color.png',
			},
			{
				id: 10,
				name: 'ANTHONY DÁVILA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/anthony-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/anthony-min.png',
			},
			{
				id: 11,
				name: 'ELENA JAPA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/elena-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/elena-min-color.png',
			},
			{
				id: 12,
				name: 'AIROM VERGARA',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/airom-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/airom-min-color.png',
			},
			{
				id: 11,
				name: 'BRAYAN SANCHEZ',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/brayan-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/brayan-min-color.png',
			},
			{
				id: 12,
				name: 'ANGELA QUISPE',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/angela-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/angela-min-color.png',
			},
			{
				id: 13,
				name: 'IESUS ALEGRE',
				carge: '',
				image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/iesus-min-1.png',
				imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/iesus-color.png',
			},
		],
		windowSize: {
			x: 0,
			y: 0,
		},
	};
}

export default {
	name: 'page-home',
	data,
	components: {
		banner,
		componentOurProducts,
		componentOurTeam,
	},
	methods: {
		onResize,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/page-home.vue